import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

let params;

const getImgDiff = async () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getStepImageDiff&companyid=${user.companyid}`,
    {
      params: params,
    },
  );

  return response.data;
};

const useStepImgDiffQuery = () => {
  const query = useQuery({
    queryKey: ["getImgDiff"],
    queryFn: () => {
      return getImgDiff(params);
    },
    enabled: false,
    retry: true,
    cacheTime: 90000,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    staleTime: Infinity,
  });

  const refetchWithParams = (queryParams) => {
    params = queryParams;
    query.refetch();
  };

  return {
    ...query,
    refetchWithParams,
  };
};

export default useStepImgDiffQuery;
